import { LevelMitSprites } from './LevelMitSprites.js';
import { 
	upgradeLocalStooorage
} from './State.js';

export const BootLogic = {
 preloadGame: (loader)=> {
	loader.image('sky', 'assets/hintergrund.svg');
	loader.image('ground', 'assets/platform.svg');
	loader.image('gameover', 'assets/gameover.svg');
	loader.image('star', 'assets/star.png');
	loader.image('start', 'assets/start.png');
	loader.image('bomb', 'assets/bomb.png');
	loader.spritesheet('heldin', './assets/heldin-opt.svg', { frameWidth: 32, frameHeight: 48 });

	loader.image('tiles', 'assets/owlishmedia_pixel_tiles.png');
	loader.tilemapTiledJSON('map', 'assets/level-1.json');

	upgradeLocalStooorage()
},

 onStartBootScene: (scene) => {
	scene.start('Tutorial')
}
}